import { Charger } from '../models/charger.interface';

export interface ChargersState {
  readonly chargers: Charger[];
}

export const initialState: ChargersState = { chargers: [] };
